(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["giraffy-bag-size-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  var NS='http://www.w3.org/2000/svg';

  function n(v){
    var x=Number(v);
    return Number.isFinite(x)?x:NaN;
  }

  function svgEl(tag,attrs,text){
    var el=document.createElementNS(NS,tag);
    Object.keys(attrs||{}).forEach(function(k){
      el.setAttribute(k,String(attrs[k]));
    });
    if(text!==undefined&&text!==null){
      el.textContent=text;
    }
    return el;
  }

  function init(root){
    if(!root||root.getAttribute('data-gs-ready')==='true') return;
    root.setAttribute('data-gs-ready','true');

    var removers=[];
    function on(el,type,fn){
      if(!el) return;
      el.addEventListener(type,fn);
      removers.push(function(){el.removeEventListener(type,fn);});
    }

    var buttons=[].slice.call(root.querySelectorAll('[data-size]'));

    var sizes=buttons.map(function(b){
      return {
        id:b.getAttribute('data-size'),
        name:b.getAttribute('data-name')||'',
        code:b.getAttribute('data-code')||'',
        outer:[
          n(b.getAttribute('data-outer-w')),
          n(b.getAttribute('data-outer-h'))
        ],
        usable:[
          n(b.getAttribute('data-usable-w')),
          n(b.getAttribute('data-usable-h'))
        ],
        color:b.getAttribute('data-color')||'#075344',
        button:b
      };
    }).filter(function(s){
      var a=s.outer.concat(s.usable);
      return a.every(function(v){return Number.isFinite(v)&&v>0;}) &&
        s.usable[0]<=s.outer[0] &&
        s.usable[1]<=s.outer[1];
    });

    var svg=root.querySelector('[data-svg]');
    var stage=root.querySelector('[data-stage]');
    var nameEl=root.querySelector('[data-name]');
    var outerEl=root.querySelector('[data-outer]');
    var usableEl=root.querySelector('[data-usable]');
    var prev=root.querySelector('[data-prev]');
    var next=root.querySelector('[data-next]');
    var unitButtons=[].slice.call(root.querySelectorAll('[data-unit]'));
    var modeButtons=[].slice.call(root.querySelectorAll('[data-mode]'));
    var compareStatus=root.querySelector('[data-compare-status]');
    var compareList=root.querySelector('[data-compare-list]');
    var singleDetails=root.querySelector('.gz-read dl');
    var singleDims=singleDetails
      ? [].slice.call(singleDetails.querySelectorAll('.gz-dim'))
      : [];
    var singleOuterDim=singleDims[0]||null;
    var singleUsableDim=singleDims[1]||null;

    var unit='in';
    var mode='single';
    var current=sizes.findIndex(function(s){
      return String(s.code).toUpperCase()==='L';
    });
    if(current<0){
      current=Math.min(2,Math.max(0,sizes.length-1));
    }

    var selected=new Set();
    if(sizes[current]){
      selected.add(sizes[current].id);
    }

    var rects=[];
    var tags=[];
    var usableRect=null;

    function oneInch(v){
      return (Math.round((v/2.54)*10)/10).toFixed(1);
    }

    function fmt(v){
      return unit==='cm'
        ? (Math.round(v*10)/10).toString()
        : oneInch(v);
    }

    function pair(p){
      return fmt(p[0])+' × '+fmt(p[1])+' '+unit;
    }

    function renderCompareDetails(){
      if(!compareList) return;

      compareList.innerHTML='';
      compareList.setAttribute('data-count',String(selected.size));

      selected.forEach(function(id){
        var item=sizes.find(function(size){
          return size.id===id;
        });

        if(!item) return;

        var row=document.createElement('div');
        row.className='gz-compare-item';

        var title=document.createElement('p');
        title.className='gz-compare-name';
        title.textContent=item.name;

        var label=document.createElement('p');
        label.className='gz-compare-outer-label';
        label.textContent='Outer size';

        var value=document.createElement('p');
        value.className='gz-compare-value';
        value.textContent=pair(item.outer);

        row.appendChild(title);
        row.appendChild(label);
        row.appendChild(value);

        compareList.appendChild(row);
      });
    }

    function clear(){
      while(svg&&svg.firstChild){
        svg.removeChild(svg.firstChild);
      }
    }

    function layout(){
      var desktop=window.innerWidth>=750;

      return desktop
        ? {
            viewW:560,
            viewH:500,
            scale:9.2,
            x0:115,
            base:470,
            labelFont:15,
            labelInsetX:9,
            labelInsetY:18
          }
        : {
            viewW:350,
            viewH:330,
            scale:5.5,
            x0:14,
            base:308,
            labelFont:11.5,
            labelInsetX:8,
            labelInsetY:17
          };
    }

    function build(){
      if(!svg||!sizes.length) return;

      clear();
      rects=[];
      tags=[];

      var L=layout();
      svg.setAttribute('viewBox','0 0 '+L.viewW+' '+L.viewH);

      var order=sizes.map(function(_,i){return i;}).sort(function(a,b){
        return sizes[b].outer[0]*sizes[b].outer[1] -
               sizes[a].outer[0]*sizes[a].outer[1];
      });

      order.forEach(function(i){
        var s=sizes[i];
        var w=s.outer[0]*L.scale;
        var h=s.outer[1]*L.scale;
        var x=L.x0;
        var y=L.base-h;

        var r=svgEl('rect',{
          x:x,
          y:y,
          width:w,
          height:h,
          rx:6,
          class:'gz-bag'
        });

        /* Keep the label inside the bag, below the top outline.
           No background chip and no line passing through the letters. */
        var t=svgEl('text',{
          x:x+w-L.labelInsetX,
          y:y+L.labelInsetY,
          'text-anchor':'end',
          class:'gz-tag',
          'font-size':L.labelFont
        },s.code);

        svg.appendChild(r);
        svg.appendChild(t);

        rects[i]=r;
        tags[i]=t;
      });

      usableRect=svgEl('rect',{
        rx:4,
        class:'gz-usable'
      });

      svg.appendChild(usableRect);
    }

    function render(){
      if(!sizes.length||!svg) return;

      current=Math.max(0,Math.min(sizes.length-1,current));
      var s=sizes[current];
      var L=layout();

      rects.forEach(function(r,i){
        if(!r) return;

        var selectedNow=selected.has(sizes[i].id);
        var active=mode==='compare'
          ? selectedNow
          : i===current;

        /* Compare mode: show ONLY selected bag outlines. */
        r.style.display=(mode==='compare' && !selectedNow)
          ? 'none'
          : '';

        r.classList.toggle('is-on',active);
        r.classList.toggle('is-focus',i===current);
      });

      tags.forEach(function(t,i){
        if(!t) return;

        var selectedNow=selected.has(sizes[i].id);
        var active=mode==='compare'
          ? selectedNow
          : i===current;

        /* Hide the matching size label with its unselected outline. */
        t.style.display=(mode==='compare' && !selectedNow)
          ? 'none'
          : '';

        t.classList.toggle('is-on',active);
      });

      var ow=s.outer[0]*L.scale;
      var oh=s.outer[1]*L.scale;
      var uw=s.usable[0]*L.scale;
      var uh=s.usable[1]*L.scale;
      var ox=L.x0;
      var oy=L.base-oh;
      var ux=ox+(ow-uw)/2;
      var topSeal=Math.max(0,(s.outer[1]-s.usable[1])*L.scale);
      var uy=oy+topSeal;

      if(usableRect){
        usableRect.setAttribute('x',ux);
        usableRect.setAttribute('y',uy);
        usableRect.setAttribute('width',uw);
        usableRect.setAttribute('height',uh);

        /* Compare mode is Outer Size only, so do not show the usable-size overlay. */
        usableRect.style.display=mode==='compare'
          ? 'none'
          : '';
      }

      if(mode==='compare'){
        if(selected.size===1){
          /* With only one compare selection, keep exactly the same
             large typography/layout as All Sizes, but show Outer Size only. */
          if(nameEl){
            nameEl.hidden=false;
            nameEl.style.display='';
            nameEl.textContent=s.name;
          }

          if(singleDetails){
            singleDetails.hidden=false;
            singleDetails.style.display='';
          }

          if(singleOuterDim){
            singleOuterDim.hidden=false;
            singleOuterDim.style.display='';
          }

          if(singleUsableDim){
            singleUsableDim.hidden=true;
            singleUsableDim.style.display='none';
          }

          if(outerEl){
            outerEl.textContent=pair(s.outer);
          }

          if(compareList){
            compareList.hidden=true;
            compareList.style.display='none';
            compareList.innerHTML='';
            compareList.removeAttribute('data-count');
          }
        }else{
          /* With 2+ selections, use the compact responsive compare list. */
          if(nameEl){
            nameEl.hidden=true;
            nameEl.style.display='none';
          }

          if(singleDetails){
            singleDetails.hidden=true;
            singleDetails.style.display='none';
          }

          if(singleUsableDim){
            singleUsableDim.hidden=true;
            singleUsableDim.style.display='none';
          }

          if(compareList){
            compareList.hidden=false;
            compareList.style.display='grid';
            renderCompareDetails();
          }
        }
      }else{
        /* All Sizes must never show any Compare Size content. */
        if(nameEl){
          nameEl.hidden=false;
          nameEl.style.display='';
          nameEl.textContent=s.name;
        }

        if(singleDetails){
          singleDetails.hidden=false;
          singleDetails.style.display='';
        }

        if(singleOuterDim){
          singleOuterDim.hidden=false;
          singleOuterDim.style.display='';
        }

        if(singleUsableDim){
          singleUsableDim.hidden=false;
          singleUsableDim.style.display='';
        }

        if(compareList){
          compareList.hidden=true;
          compareList.style.display='none';
          compareList.innerHTML='';
          compareList.removeAttribute('data-count');
        }

        if(outerEl) outerEl.textContent=pair(s.outer);
        if(usableEl) usableEl.textContent=pair(s.usable);
      }

      if(mode==='compare'){
        var selectedIndexesForNav=sizes
          .map(function(item,index){
            return selected.has(item.id)
              ? index
              : -1;
          })
          .filter(function(index){
            return index>=0;
          });

        var selectedPosition=selectedIndexesForNav.indexOf(current);

        if(prev){
          prev.disabled=
            selectedPosition<=0;
        }

        if(next){
          next.disabled=
            selectedPosition<0 ||
            selectedPosition>=selectedIndexesForNav.length-1;
        }
      }else{
        if(prev) prev.disabled=current===0;
        if(next) next.disabled=current===sizes.length-1;
      }

      buttons.forEach(function(b,i){
        var active=mode==='compare'
          ? selected.has(sizes[i].id)
          : i===current;

        b.setAttribute('aria-checked',active?'true':'false');
        b.classList.toggle('is-current',i===current);
        b.tabIndex=i===current?0:-1;
      });

      unitButtons.forEach(function(b){
        b.setAttribute(
          'aria-pressed',
          b.getAttribute('data-unit')===unit?'true':'false'
        );
      });

      modeButtons.forEach(function(b){
        b.setAttribute(
          'aria-pressed',
          b.getAttribute('data-mode')===mode?'true':'false'
        );
      });

      if(compareStatus){
        if(mode==='compare' && selected.size===1){
          compareStatus.hidden=false;
          compareStatus.style.display='';
          compareStatus.textContent='Select one more size to compare.';
        }else{
          compareStatus.hidden=true;
          compareStatus.style.display='none';
          compareStatus.textContent='';
        }
      }
    }

    function select(i,focus){
      current=Math.max(0,Math.min(sizes.length-1,i));

      if(mode==='single'){
        selected.clear();
        if(sizes[current]){
          selected.add(sizes[current].id);
        }
      }

      render();

      if(focus&&buttons[current]){
        buttons[current].focus();
      }
    }

    buttons.forEach(function(b,i){
      on(b,'click',function(){
        if(mode==='compare'){
          var id=sizes[i].id;

          if(selected.has(id)){
            if(selected.size>1){
              selected.delete(id);

              /* If the current bag was removed, focus another selected bag. */
              if(current===i){
                var replacement=sizes.findIndex(function(item){
                  return selected.has(item.id);
                });

                if(replacement>=0){
                  current=replacement;
                }
              }
            }
          }else{
            selected.add(id);
            current=i;
          }

          render();
          return;
        }

        select(i);
      });
    });

    modeButtons.forEach(function(b){
      on(b,'click',function(){
        mode=b.getAttribute('data-mode')==='compare'
          ? 'compare'
          : 'single';

        if(mode==='compare' && sizes[current]){
          selected.add(sizes[current].id);
        }

        if(mode==='single'){
          selected.clear();
          if(sizes[current]){
            selected.add(sizes[current].id);
          }

          if(compareList){
            compareList.hidden=true;
            compareList.style.display='none';
            compareList.innerHTML='';
            compareList.removeAttribute('data-count');
          }

          if(compareStatus){
            compareStatus.hidden=true;
            compareStatus.style.display='none';
            compareStatus.textContent='';
          }
        }

        render();
      });
    });

    unitButtons.forEach(function(b){
      on(b,'click',function(){
        unit=b.getAttribute('data-unit')==='cm'?'cm':'in';
        render();
      });
    });

    function move(direction){
      if(mode!=='compare'){
        select(current+direction);
        return;
      }

      var selectedIndexes=sizes
        .map(function(item,index){
          return selected.has(item.id)
            ? index
            : -1;
        })
        .filter(function(index){
          return index>=0;
        });

      if(!selectedIndexes.length){
        return;
      }

      var position=selectedIndexes.indexOf(current);

      if(position<0){
        current=selectedIndexes[0];
      }else{
        var nextPosition=position+direction;

        if(nextPosition<0){
          nextPosition=0;
        }

        if(nextPosition>selectedIndexes.length-1){
          nextPosition=selectedIndexes.length-1;
        }

        current=selectedIndexes[nextPosition];
      }

      render();
    }

    on(prev,'click',function(){move(-1);});
    on(next,'click',function(){move(1);});

    var sx=null;
    var sy=null;

    on(stage,'pointerdown',function(e){
      if(e.target.closest&&e.target.closest('.gz-nav')){
        sx=null;
        sy=null;
        return;
      }
      sx=e.clientX;
      sy=e.clientY;
    });

    on(stage,'pointerup',function(e){
      if(sx===null||sy===null) return;

      var dx=e.clientX-sx;
      var dy=e.clientY-sy;
      sx=null;
      sy=null;

      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)){
        select(dx<0?current+1:current-1);
      }
    });

    var rail=root.querySelector('.gz-rail');
    on(rail,'keydown',function(e){
      if(e.key==='ArrowRight'||e.key==='ArrowDown'){
        e.preventDefault();
        select(current+1,true);
      }
      if(e.key==='ArrowLeft'||e.key==='ArrowUp'){
        e.preventDefault();
        select(current-1,true);
      }
    });

    on(root,'shopify:block:select',function(e){
      var blockId=e&&e.detail&&e.detail.blockId;
      var idx=sizes.findIndex(function(s){return s.id===blockId;});
      if(idx>=0){
        select(idx);
      }
    });

    var lastDesktop=window.innerWidth>=750;
    on(window,'resize',function(){
      var nowDesktop=window.innerWidth>=750;
      if(nowDesktop!==lastDesktop){
        lastDesktop=nowDesktop;
        build();
        render();
      }
    });

    build();
    render();

    root._gsCleanup=function(){
      removers.forEach(function(fn){fn();});
      root.removeAttribute('data-gs-ready');
    };
  }

  function initAll(scope){
    var p=scope||document;

    if(
      p.nodeType===1 &&
      p.matches &&
      p.matches('[data-giraffy-bag-guide]')
    ){
      init(p);
    }

    var all=p.querySelectorAll
      ? p.querySelectorAll('[data-giraffy-bag-guide]')
      : [];

    [].forEach.call(all,init);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){
      initAll(document);
    });
  }else{
    initAll(document);
  }

  document.addEventListener('shopify:section:load',function(e){
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload',function(e){
    var g=e.target&&e.target.querySelector
      ? e.target.querySelector('[data-giraffy-bag-guide]')
      : null;

    if(g&&typeof g._gsCleanup==='function'){
      g._gsCleanup();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
